import * as React from 'react';


export default class EditActive extends React.Component {
  constructor(props){
    super(props);
  }
  render() {
    return (
      <svg className={this.props.className} xmlnsXlink="http://www.w3.org/1999/xlink">
       <path fill="#727272" d="M14.093 1.906c-1.205-1.208-3.165-1.208-4.37 0l-8.012 8.01c-.063.063-.102.144-.113.23l-.594 4.398c-.018.125.027.25.113.337.075.074.18.119.284.119.018 0 .035 0 .053-.003l2.65-.358c.22-.03.375-.233.345-.453-.03-.221-.232-.376-.453-.347l-2.124.287.415-3.067 3.227 3.228c.075.075.18.12.284.12.104 0 .208-.042.283-.12l8.012-8.01c.585-.585.907-1.36.907-2.187 0-.826-.322-1.602-.907-2.184zm-4.215.985l1.346 1.345-7.312 7.312-1.345-1.345L9.878 2.89zM5.801 13.434l-1.316-1.316 7.311-7.312 1.316 1.316L5.8 13.434zm7.872-7.888l-3.219-3.22c.409-.336.919-.521 1.456-.521.611 0 1.184.238 1.616.668.433.43.669 1.005.669 1.617 0 .54-.185 1.047-.522 1.456z"/>
      </svg>
    )
  }
}
